export let TenantStatus = /*#__PURE__*/function (TenantStatus) {
  TenantStatus["TRIAL"] = "trial";
  TenantStatus["ACTIVE"] = "active";
  TenantStatus["GRACE"] = "grace";
  TenantStatus["SUSPENDED"] = "suspended";
  TenantStatus["DELETED"] = "deleted";
  return TenantStatus;
}({});
export const TENANT_STATUS = TenantStatus;
//# sourceMappingURL=tenant.enum.js.map